export default __webpack_public_path__ + "static/media/no-results.3ac62018.svg";